<template>
  <svg id="min" viewBox="0 0 64 64">
    <svg>
      <path
        d="M32,64C14.4,64,0,49.6,0,32C0,14.4,14.4,0,32,0s32,14.4,32,32C64,49.6,49.6,64,32,64z M32,4.6C16.9,4.6,4.6,16.9,4.6,32
                    S16.9,59.4,32,59.4c15.1,0,27.4-12.3,27.4-27.4S47.1,4.6,32,4.6z"
      />
    </svg>
    <rect x="25.6" y="29.1" width="12.8" height="5.9" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconMin extends Vue {}
</script>
